module.exports = __webpack_public_path__ + "img/message-image.25391f73.svg";